import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "config/config";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CreateDocumentModal = ({
  show,
  handleClose,
  onDocumentCreated,
  foldersAdd,
}) => {
  const [form, setForm] = useState({
    title: "",
    author: "",
    tags: "",
    folderId: "",
    version: 1,
    file: null, // fichier
  });
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  console.log(companyId);
  const { t } = useTranslation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, file: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", form.title);
      formData.append("author", form.author);
      formData.append("tags", form.tags);
      formData.append("folderId", form.folderId);
      formData.append("version", form.version);
      formData.append("file", form.file); // 👈 fichier
      formData.append("companyId", companyId);
      const res = await axios.post(
        `${BASE_URL}documentsFile/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (onDocumentCreated) onDocumentCreated(res.data);

      handleClose();
      setForm({
        title: "",
        author: "",
        tags: "",
        folderId: "",
        version: 1,
        file: null,
      });
    } catch (err) {
      console.error(err);
      alert(t("ged.errorUploadingDocument"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      style={{ borderRadius: "15px" }}
      className="modal-create-folder"
      id={"modal-create-folder"}>
      <Modal.Header closeButton>
        <Modal.Title> {t("ged.uploder")} </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{t("ged.title")}</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("ged.auteur")}</Form.Label>
            <Form.Control
              type="text"
              name="author"
              value={form.author}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("ged.tags")}</Form.Label>
            <Form.Control
              type="text"
              name="tags"
              value={form.tags}
              onChange={handleChange}
              placeholder="ex: contrat, RH, 2025"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("ged.dossier")}</Form.Label>
            <Form.Select
              name="folderId"
              value={form.folderId}
              onChange={handleChange}>
              <option value="">-- {t("ged.choisierDos")} --</option>
              {foldersAdd.map((folder) => (
                <option key={folder._id} value={folder._id}>
                  {folder.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("ged.version")}</Form.Label>
            <Form.Control
              type="number"
              name="version"
              value={form.version}
              onChange={handleChange}
              min="1"
            />
          </Form.Group>

          {/* ✅ Input fichier */}
          <Form.Group className="mb-3">
            <Form.Label>{t("ged.fichier")}</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} required />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="btn-create w-100 " type="submit">
            {t("ged.uploderr")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateDocumentModal;
